export default {
  title: 'Allergener',
  description: 'Vær opmærksom på, at denne {{product}} kan indeholde følgende ingredienser eller produkter heraf:',
  options: {
    dairy: 'Mejeri/mælk',
    eggs: 'Æg',
    fish: 'Fisk',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: 'Jordnødder',
    sesame: 'Sesam',
    shellfish: 'Skaldyr',
    soy: 'Soja',
    tree_nuts: 'Trænødder',
    celery: 'Selleri',
    crustaceans: 'Krebsdyr',
    lupin: 'Lupin',
    molluscs: 'Bløddyr',
    mustard: 'Sennep',
    nuts: 'Nødder',
    sulphites: 'Sulfitter',
    almonds: 'Mandler',
    barley: 'Byg',
    brazil_nuts: 'Paranødder',
    cashew: 'Cashewnødder',
    hazelnuts: 'Hasselnødder',
    kamut: 'Kamut',
    macadamia: 'Macadamianødder',
    oats: 'Havre',
    pecan: 'Pekannødder',
    pistachios: 'Pistacienødder',
    rye: 'Rug',
    spelt: 'Spelt',
    walnuts: 'Valnødder',
    wheat: 'Hvede',
    sugared_drink: 'Sukkerholdig drik',
    lentils: 'Linser',
    queensland_nuts: 'Queenslandnødder',
  },
};
